export interface VSTResult {
  ages: number[];
  currentPaidPremiums: number[];
  totalDeathBenefits: VSTSeries;
  totalCashValues: VSTSeries;
  guaranteedDeathBenefits: VSTSeries;
  guaranteedCashValues: VSTSeries;
  accumulatedPaidPremium: VSTSeries;
  mecYear: number;
  annualDividendEndYear?: VSTSeries;
  paidUpAdditionsEndYear?: VSTSeries;
  netOutlay?: VSTSeries;
  surrenderAmount?: VSTSeries;
  annualLoan?: VSTSeries;
  netSurrenderValue?: VSTSeries;
  netDeathBenefit?: VSTSeries;
  solvedValue?: number;
  combinedTotalBenefit?: VSTSeries;
  cumulativeRetirementIncome?: VSTSeries;
  totalIncome?: number;
  highestBenefitAgeIndex?: number;
}

export interface VSTSeries {
  name: string;
  dashStyle: string;
  tooltip: string;
  data: number[];
  color: string;
}

export interface VSTChartLabelValues {
  totalDeathBenefits: string;
  totalCashValues: string;
  guaranteedDeathBenefits: string;
  guaranteedCashValues: string;
  accumulatedPaidPremium: string;
}

export interface ConceptIllustrationChartLegendLabels {
  totalCashValues: string;
  netDeathBenefit: string;
  combinedTotalBenefit?: string;
  cumulativeRetirementIncome?: string;
  retirementIncome?: string;
}

export interface VSTLabelEvent {
  series: string;
  label: string;
  displayState: boolean;
}

export interface VSTClientInfo {
  dividendOption: string;
  rateClass: string;
}

export const DEFAULT_AGE: number = 66;
